<template>
  <el-tabs v-model="ticket_dashboard_tab_name" class="tickets-dashboard-tabs">
    <el-tab-pane label="Dashboard" name="dashboard">
      <span slot="label">
        <i class="el-icon-s-data"></i>
        <span class="description-text">Dashboard</span>
      </span>

      <!-- Summary -->
      <tickets-dashboard-summary></tickets-dashboard-summary>

      <!-- Filters -->
      <ticket-dashboard-filters></ticket-dashboard-filters>

      <!-- Graph -->
      <div class="graph-container">
        <component :is="dashboardGraph"></component>
      </div>

      <!-- Table -->
      <div class="table-container">
        <component :is="dashboardTable"></component>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ticketDashboardMixins from '../../../../../mixins/ticketDashboardMixins';
import TicketsDashboardSummary from './TicketsDashboardSummary.vue';
import TicketDashboardFilters from './TicketDashboardFilters.vue';
import TicketsLocationGraph from './TicketsLocationGraph.vue';
import TicketsLocationTable from './TicketsLocationTable.vue';
import TicketsAgentGraph from './TicketsAgentGraph.vue';
import TicketsAgentTable from './TicketsAgentTable.vue';
import TicketsPriorityGraph from './TicketsPriorityGraph.vue';
import TicketsPriorityTable from './TicketsPriorityTable.vue';
import TicketsResolutionGraph from './TicketsResolutionGraph.vue';
import TicketsResolutionTable from './TicketsResolutionTable.vue';
import TicketsCategoryGraph from './TicketsCategoryGraph.vue';
import TicketsCategoryTable from './TicketsCategoryTable.vue';
export default {
  name: "TicketsDashboardTabs",
  components: {
    TicketsDashboardSummary,
    TicketDashboardFilters,
    'location-graph': TicketsLocationGraph,
    'location-table': TicketsLocationTable,
    'agent-graph': TicketsAgentGraph,
    'agent-table': TicketsAgentTable,
    'priority-graph': TicketsPriorityGraph,
    'priority-table': TicketsPriorityTable,
    'resolution-graph': TicketsResolutionGraph,
    'resolution-table': TicketsResolutionTable,
    'category-graph': TicketsCategoryGraph,
    'category-table': TicketsCategoryTable,
  },
  mixins: [ticketDashboardMixins]
}
</script>